import { useTranslation } from 'react-i18next'
import { NoResultsIllustration } from '@/components/NoResultsIllustration'

export function NoResults() {
  const { t } = useTranslation()

  return (
    <div className="products-gallery__no-results" data-testid="products-gallery-no-results">
      <NoResultsIllustration />
      <h2>{t('results-not-found')}</h2>
      <p>{t('no-results-gallery-descr')}</p>
    </div>
  )
}
